export default {
  SSR_GQL_ENDPOINT: process.env.SSR_GQL_ENDPOINT || 'http://localhost:5000/api',
  IMAGE_CDN_DOMAIN: process.env.IMAGE_CDN_DOMAIN || 'https://teja8.kuikr.com',
  STATIC_FILE_PATH: process.env.STATIC_FILE_PATH || 'clsfd',
  MAX_SIZE_IMAGE: process.env.MAX_SIZE_IMAGE || 4,
  QKR_RAVEN: process.env.QKR_RAVEN || 'https://raven.kuikr.com/upload',
  RAVEN_PROCESS: process.env.RAVEN_PROCESS || 'https://raven.kuikr.com/cf/ImageProcess.php',
  STATIC_DOMAIN: process.env.STATIC_DOMAIN || 'https://teja9.kuikr.com'
};
